module.exports = __webpack_public_path__ + "static/media/belcolor__13.cab3a1dd.jpg";